<template lang="pug">
</template>
<script>
import Base from 'views/Base';

export default {
    name: 'TempPage',
    extends: Base,
    data() {
        const { moduleId, pagePath } = this.$route.params;
        this.$router.replace({
            name: 'Page',
            params: { moduleId, pagePath }
        });
        return {
            loading: false,
        };
    },
};
</script>



// WEBPACK FOOTER //
// src/components/views/TempPage.vue